export default __webpack_public_path__ + "static/media/grueess-di-gott-du-liebe-frueelig.59900be4.webp";